import React from 'react'
import { NavDropdown } from 'react-bootstrap'
import PropTypes from 'prop-types'

import './dropDown.scss'

class DropDownComponent extends React.Component {
    constructor(props) {
        super(props)

        this.state = {
            isOpen: false,
        }
    }
    open = () => {
        this.setState({
            isOpen: !this.state.isOpen,
        })
    }
    render() {
        const props = this.props
        const { title, children, className } = props
        const { isOpen } = this.state
        return <NavDropdown
            {...props}
            className={'Drop-down-component ' + className}
            onToggle={this.open}
            title={<span>
                {title}
                <span className={`arrow-icon ${isOpen && 'reverse'}`} />
            </span>}
            noCaret
        >
            {children}
        </NavDropdown>
    }
}

DropDownComponent.propTypes = {
    ...NavDropdown.propTypes,
    children: PropTypes.node.isRequired,
}

export default DropDownComponent



// WEBPACK FOOTER //
// ./src/components/core/DropDownComponent/DropDownComponent.js